import config from '../../config/app';
import localforage from "localforage";
localforage.config();

export const loadState = async () => {
	try {
		const parsedState = await localforage.getItem('state');
		if (parsedState.app.version < config.store_version) {
			localforage.removeItem('state');
			return undefined
		}
		if (parsedState === null) {
			return undefined
		}
		return parsedState;
	} catch (err) {
		console.log('Get Parsed State Error:', err);
		return undefined;
	}
}

export const saveState = async (state) => {
	// Set auth state
	const authState = {
		User: state.User,
		app: state.app
	};

	let sentryUser = null;
	if(typeof(localStorage.getItem("sentry-user"))=='undefined'){
		sentryUser = JSON.parse(localStorage.getItem('sentry-user'));
	}
	
	if (state.User.User.id && state.User.User.email) {
		if (sentryUser === null || sentryUser.email === undefined || state.User.User.email != sentryUser.email) {
			const updateSentryUser = JSON.stringify({
				id: state.User.User.id,
				email: state.User.User.email
			});
			localStorage.setItem('sentry-user', updateSentryUser);		
		}
	}

	const serialisedState = JSON.stringify(authState);
	localStorage.setItem('state', serialisedState);
	
	const checkNoFunction = function(obj1) {
		let noFunctions = true;
		if (obj1 !== undefined && obj1 !== null) {
			const obj1Keys = Object.keys(obj1);
		
			if(obj1Keys.length) {
				for (var i = 0; i < obj1Keys.length; i++) {
					let key = obj1Keys[i];
					
					if(typeof obj1[key] === "object") {
						if(!checkNoFunction(obj1[key])) {
							noFunctions = false;
						}
					} else if (typeof obj1[key] === "function") {
						noFunctions = false;
					}
					// if (key === 'assignSessionTherapyArea') {
					// 	console.log(`${key}: ${obj1[key]}`);
					// 	console.log(`Check of ${key} is object:`, typeof obj1[key] === "object");
					// 	console.log(`Check of ${key} is function:`, typeof obj1[key] === "function");
					// 	console.log(`No Function result:`, nofunctions);
					// }
					if (!noFunctions) {
						break;
					}
				}
			}
		}
		
		return noFunctions;
	};

	if (checkNoFunction(state)) {
		// console.log('No Functions');
		localforage.setItem('state', state).then(function () {
			// console.log('save state 1:');
			return localforage.getItem('state');
		}).then(function (state) {
			// console.log('save state 2:', state);
		}).catch(function (err) {
			console.log('save state err', err)
			console.log('Error state:', state);
		});
	}
}



// WEBPACK FOOTER //
// ./src/store/persist.js